module.exports = __webpack_public_path__ + "img/reservisten.ef1e404b.jpg";